import { ArrowLittleRightIcon, Button } from '@joinrepublic/dls-ui-kit';
import NextLink from 'next/link';

import { SEE_ALL_LABEL } from '../section-header/constants';
import { ISeeAllButtonProps } from './types';

/**
 * Full-width "See all" under a card section — what the design gives a section
 * whose mobile layout is a list rather than a scroller, since a list has no
 * terminating `SeeAllTile` to run into.
 *
 * Distinct from `SeeAllTile`, which is a slide inside a rail.
 */
export const SeeAllButton = ({
  href,
  isExternal = false,
  onClick,
}: ISeeAllButtonProps) => {
  return (
    <Button
      as={isExternal ? 'a' : NextLink}
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      onClick={onClick}
      variant="secondary"
      size="lg"
      width="full"
      rightIcon={<ArrowLittleRightIcon size="small" />}
    >
      {SEE_ALL_LABEL}
    </Button>
  );
};
